import React from 'react';

export default function NavBtn({ active, onClick, Icon, label, collapsed }) {
  return (
    <button
      className={`nav-item ${active ? 'active' : ''}`}
      onClick={onClick}
      title={collapsed ? label : undefined}
    >
      <Icon size={15} />
      <span className="nav-item-label">{label}</span>
    </button>
  );
}
